module.exports = __webpack_public_path__ + "assets/images/YellowCreditPage.b1fde4c5fc045b545dc7ddb36e72e319.png";